import { Grid, Typography } from '@mui/material'
import { styled } from '@mui/system'
import PropTypes from 'prop-types'
import React from 'react'
import { useSelector } from 'react-redux'
import { capitalizeFirstLetter, getSoIdNumber, toFixedIfNull } from '../../../../../helpers'
import { useDefaultComponentTools } from '../../../../../hooks/useDefaultComponentTools'
import { selectDefaultAssetInfo, selectLotSize } from '../../../../../store/redusers/assets/selectors'
import { selectPipValue } from '../../../../../store/redusers/orders/selectors'

export const SidebarTitle = styled(Typography)(({ theme }) => ({
	color: theme.palette.mode === 'dark' ? '#6B6F77' : '#7C8DA7',
	fontSize: '14px'
}))

function SidebarInfoBasic({assetInfo}) {
	const {t} = useDefaultComponentTools()
	const assetLotSize = useSelector(selectLotSize(getSoIdNumber(assetInfo.assetSoId)))
	const pipValue = useSelector(selectPipValue)
	const defaultAsset = useSelector(selectDefaultAssetInfo)

	return (
		<Grid container sx={{ borderBottom: '1px solid #F6F7F9', mb: 4, pb: 2 }}>
			<Grid item sx={{ p: 2 }} xs={6}>
				<SidebarTitle>{t('Asset class')}</SidebarTitle>
				<Typography fontSize={'18px'} fontWeight={'bold'} sx={{
					mt: 1
				}}>{t(capitalizeFirstLetter(assetInfo.assetType, true))}</Typography>
			</Grid>
			<Grid item sx={{ p: 2 }} xs={6}>
				<SidebarTitle>{t('Pip Value')}</SidebarTitle>
				<Typography fontSize={'18px'} fontWeight={'bold'} sx={{
					mt: 1
				}}>{pipValue}</Typography>
			</Grid>
			<Grid item sx={{ p: 2 }} xs={6}>
				<SidebarTitle>{t('Contract size')}</SidebarTitle>
				<Typography fontSize={'18px'} fontWeight={'bold'} sx={{
					mt: 1
				}}>{assetLotSize}</Typography>
			</Grid>
			<Grid item sx={{ p: 2 }} xs={6}>
				<SidebarTitle>{t('Last Price')}</SidebarTitle>
				<Typography fontSize={'18px'} fontWeight={'bold'} sx={{
					mt: 1
				}}>{toFixedIfNull(defaultAsset.lastPrice, 5)}</Typography>
			</Grid>
			<Grid item sx={{ p: 2 }} xs={6}>
				<SidebarTitle>{t('Last Ask')}</SidebarTitle>
				<Typography fontSize={'18px'} fontWeight={'bold'} sx={{
					mt: 1
				}}>{defaultAsset.lastAsk}</Typography>
			</Grid>
			<Grid item sx={{ p: 2 }} xs={6}>
				<SidebarTitle>{t('Last Bid')}</SidebarTitle>
				<Typography fontSize={'18px'} fontWeight={'bold'} sx={{
					mt: 1
				}}>{defaultAsset.lastBid}</Typography>
			</Grid>
		</Grid>
	)
}

SidebarInfoBasic.propTypes = {
	assetInfo: PropTypes.object
}
export default SidebarInfoBasic
